<template>

	<div ref='_window' er-notifications-flyout>

		<NotificationsWindow
			v-for='item in items'
			:ref='Open_item'
			:er-notification-window='item.type'
			:timeout='{ amount: item.timeout, color: item.type }'
			>
			<div class='message'>{{ item.message }}</div>
			<div class='actions'>
				<a wf-button='tool' v-for='action in item.actions' @click='action.fn( ...action.params )'>{{ action.label }}</a>
			</div>
		</NotificationsWindow>

	</div>

</template>


<script setup>

	import { nextTick, ref } from 'vue';
	import * as Notifications from '@/modules/notifications';
	import NotificationsWindow from '@/_to_review/notifications/NotificationsWindow.vue';

	const _window = ref();

	const items = Notifications.Get_items();

	const exposed_funcs =
	{
		Show,
		Hide
	};

	defineExpose( exposed_funcs );


	//


	function Show ()
	{

	}


	function Hide ()
	{

	}


	async function Open_item ( element )
	{
		await nextTick();

		if ( element )
			element.Open();
	}

</script>


<style scoped>



</style>